import { DR750_2CH_LTE } from "./DR750_2CH_LTE";
import { DR900X_2CH } from "./DR900X_2CH";
import { DR900S_1CH } from "./DR900S_1CH";
import { DR750S_1CH } from "./DR750S_1CH";
import { DR750S_2CH } from "./DR750S_2CH";
import { DR900S_2CH } from "./DR900S_2CH";
import { DR750G_1CH } from "./DR750G_1CH";
import { DR750G_2CH } from "./DR750G_2CH";
import { DR750X_1CH } from "./DR750X_1CH";
import { DR750X_2CH } from "./DR750X_2CH";
import { DR900X_1CH } from "./DR900X_1CH";
import { DR750G_1CH_PRO } from "./DR750G_1CH_PRO";
import { DR750G_2CH_PRO } from "./DR750G_2CH_PRO";
import { DR750X_Plus } from "./DR750X_Plus";
import { DR900X_Plus } from "./DR900X_Plus";
import { DR750G_PRO } from "./DR750G_PRO";
import { DR750X_3CH_Plus } from "./DR750X_3CH_Plus";
import { DR750X_LTE_Plus } from "./DR750X_LTE_Plus";
import { DR770X } from "./DR770X";
import { BlackVue_7G_PRO } from "./BlackVue_7G_PRO";
import { DR970X } from "./DR970X";
import { DR770X_Box } from "./DR770X_Box";
import { DR770X_LTE } from "./DR770X_LTE";
import { DR970X_LTE } from "./DR970X_LTE";
import { DR800_GOLD } from "./DR800_GOLD";

interface IConfigOption {
  key: string;
  value: string;
}

export interface ITimeConfig {
  GpsSync: object;
  TimeSet: object;
}

export interface IVideoConfig {
  ImageSetting?: { options: IConfigOption[] };
  VideoQuality?: { options: IConfigOption[]; options4k?: IConfigOption[] };
  NightVision?: { options: IConfigOption[]; disabled?: boolean };
  VCodecType?: object;
  FrontBrightness?: object;
  RearBrightness?: object;
}

export interface IRecordingConfig {
  NormalRecord: object;
  AutoParking: object;
  RearParkingMode?: {
    explain?: string;
  };
  InteriorParkingMode?: object;
  VoiceRecord: object;
  DateDisplay: object;
  SpeedUnit: object;
  UseGpsInfo: object;
  RecordTime: {
    options: IConfigOption[];
    options4k?: IConfigOption[];
  };
  LockEvent: object;
  FrontRotate: object;
  RearRotate?: {
    options: IConfigOption[];
  };
  InteriorRotate?: object;

  // blackvue 7 box 모델 옵션 카메라 설정 추가
  OptionRearParkingMode?: object;
  // mantis - 8647, 7 box 모델 checkbox-> selectbox로 변경 타입수정
  OptionRearRotate?: {
    options: IConfigOption[];
  };
}

export interface IGSensorConfig {
  Normal: object;
  Parking: object;
}

export interface IMotionDetectionConfig {
  MOTIONSENSOR?: object;
}

export interface ISystemConfig {
  LED?: {
    RECLED: object;
    NORMALLED: object;
    PARKINGLED: object;
    RearLED?: object;
    WifiLED: object;
    InteriorLED?: object;
    LTELED?: object;
    BTLED?: object;
    OptionRearLED?: object;
  };
  PSENSOR?: object;
  VoiceGuidance?: {
    STARTVOICE: object;
    NORMALSTARTVOICE: object;
    EVENTSTARTVOICE: object;
    CHANGERECORDMODEVOICE: object;
    ENDVOICE: object;
    SPEEDALERTVOICE: object;
    ACCELERATIONVOICE?: object;
    HARSHBRAKINGVOICE?: object;
    SHARPTURNVOICE?: object;
    CHANGECONFIGVOICE: object;
    PARKINGEVENTVOICE: object;
    CLOUDVOICE: object;
  };
  VOLUME?: object;
  ScheduledReboot?: object;
  SpeedAlert?: object;
  ADAS?: object;
  BatteryProtection?: object;
  BatteryProtectionRev?: {
    minVolt: number;
    maxVolt: number;
    defaultVolt: number;
    minVoltHeavy: number;
    maxVoltHeavy: number;
    defaultVoltHeavy: number;
    defaultTime: string;
    minTime: string;
    maxTime: string;
    LowvoltageVolt: { [key: string]: string };
    LowvoltageVoltHeavy: { [key: string]: string };
  };
  LowvoltageVolt?: object;
  LowvoltageTime?: object;
  UserTextOverlay?: object;
  EventRev?: object;
  // 이벤트 감지 고도화
  EventRev2?: object;
  DMS?: object;
  Seamless?: object;
}

export interface IWifiConfig {
  LoginCredentials: object;
  WifiSleepMode?: object;
  onstart_LTE?: object;
  onstart?: object;
  WifiBand?: object;
}

export interface ICloudConfig {
  CloudService: object;
  sta1: object;
  sta2: object;
  sta3: object;
}

type FirmwareLanguage =
  | "English"
  | "Japan"
  | "China"
  | "German"
  | "French"
  | "Thai"
  | "Idn"
  | "Vietnam"
  | "Spain"
  | "Italian"
  | "Dutch"
  | "Polish"
  | "Norwegian"
  | "Finnish"
  | "Arabic"
  | "Korea";

export type FirmwareVersion = "default" | number;
export type DeviceFirmwareConfig = {
  [key in FirmwareVersion]: IFirmwareConfig;
};

export interface IFirmwareConfig {
  Time?: ITimeConfig;
  Video?: IVideoConfig;
  Recording?: IRecordingConfig;
  Gsensor?: IGSensorConfig;
  MotionDetection?: IMotionDetectionConfig;
  System?: ISystemConfig;
  Wifi?: IWifiConfig;
  Cloud?: ICloudConfig;
  FirmwareLanguage?: FirmwareLanguage[];
  DMS?: object;
  CloudNative?: object;
  CloudNative3?: object;
  UXUI?: object;
  CloudNative4?: object;
  HDLiveview?: object;
}

export type SETTING_TABS =
  | "Recording"
  | "Time"
  | "Video"
  | "Gsensor"
  | "MotionDetection"
  | "Cloud"
  | "FirmwareLanguage"
  | "System"
  | "Wifi";

export type FW_VERSION = "default" | number;
export type MODEL_KEY =
  | "DR750-2CH LTE"
  | "DR750S-1CH"
  | "DR750S-2CH"
  | "DR750G-1CH"
  | "DR750G-2CH"
  | "DR750G Pro"
  | "DR750G-1CH Pro"
  | "DR750G-2CH Pro"
  | "DR750X-1CH"
  | "DR750X-2CH"
  | "DR750X Plus"
  | "DR750X-3CH Plus"
  | "DR750X LTE Plus"
  // | "DR750K LTE"
  | "DR900S-1CH"
  | "DR900S-2CH"
  | "DR900X-1CH"
  | "DR900X-2CH"
  | "DR900X Plus"
  | "DR770X"
  | "BlackVue 7G Pro"
  | "DR970X"
  | "DR770X Box"
  | "DR770X LTE"
  | "DR970X LTE"
  | "DR800 GOLD";

export const SUPPORT_REBOOT_FW: { [key in MODEL_KEY]: number } = {
  "DR750X Plus": 1.003,
  "DR750-2CH LTE": 1.008,
  "DR900X-1CH": 1.008,
  "DR900X-2CH": 1.008,
  "DR900S-1CH": 1.014,
  "DR900S-2CH": 1.014,
  "DR750X-1CH": 1.008,
  "DR750X-2CH": 1.008,
  "DR750S-1CH": 1.019,
  "DR750S-2CH": 1.019,
  "DR750G-1CH": 1.004,
  "DR750G-2CH": 1.004,
  "DR750G-1CH Pro": 1.004,
  "DR750G-2CH Pro": 1.004,
  "DR750G Pro": 1.004,
  // "DR750K LTE": 1.0,
  "DR750X LTE Plus": 1.0,
  "DR900X Plus": 1.0,
  "DR750X-3CH Plus": 0,
  DR770X: 0,
  "BlackVue 7G Pro": 0,
  DR970X: 0,
  "DR770X Box": 0,
  "DR770X LTE": 0,
  "DR970X LTE": 0,
  "DR800 GOLD": 0,
};

export const FIRMWARE_SETTINGS: {
  [key in MODEL_KEY]: { [key in FW_VERSION]: IFirmwareConfig };
} = {
  "DR750-2CH LTE": DR750_2CH_LTE,
  //750S
  "DR750S-1CH": DR750S_1CH,
  "DR750S-2CH": DR750S_2CH,

  //750G
  "DR750G-1CH": DR750G_1CH,
  "DR750G-2CH": DR750G_2CH,
  "DR750G Pro": DR750G_PRO,
  "DR750G-1CH Pro": DR750G_1CH_PRO,
  "DR750G-2CH Pro": DR750G_2CH_PRO,
  //750X
  "DR750X-1CH": DR750X_1CH,
  "DR750X-2CH": DR750X_2CH,
  "DR750X Plus": DR750X_Plus,
  "DR750X-3CH Plus": DR750X_3CH_Plus,
  "DR750X LTE Plus": DR750X_LTE_Plus,
  // "DR750K LTE": DR750K_LTE,
  //900S
  "DR900S-1CH": DR900S_1CH,
  "DR900S-2CH": DR900S_2CH,
  //900X
  "DR900X-1CH": DR900X_1CH,
  "DR900X-2CH": DR900X_2CH,
  "DR900X Plus": DR900X_Plus,
  DR770X: DR770X,
  "BlackVue 7G Pro": BlackVue_7G_PRO,
  DR970X: DR970X,
  "DR770X Box": DR770X_Box,
  "DR770X LTE": DR770X_LTE,
  "DR970X LTE": DR970X_LTE,
  "DR800 GOLD": DR800_GOLD,
};
